import { TextBadge, HEADLINE_1 } from "@hireart/component-library";
import PropTypes from "prop-types";
import {
  DrawerHeader,
  DrawerTitle,
  DrawerDescription,
} from "common/components/Drawer";
import { WeekStatusBadge } from "common/components/WeekStatusBadge";
import {
  calculateShiftNetHoursSafe,
  formatDurationFromHours,
  formatShiftDate,
  ShiftShape,
} from "common/utils/timesheet";

export const ShiftHeader = ({ shift, shiftDate, weekStatus = "draft" }) => {
  // Calculate net hours for display - use manager override if present
  const netHours = calculateShiftNetHoursSafe(shift, {
    accountForManagerOverrides: true,
  });

  return (
    <DrawerHeader className="shrink-0 gap-4 p-16">
      <div className="flex items-start justify-between">
        <DrawerTitle className="flex flex-col items-start gap-4">
          <span className={HEADLINE_1}>
            Shift on {formatShiftDate(shiftDate)}
          </span>
        </DrawerTitle>
        {!!netHours && (
          <TextBadge
            color={shift.anyValueOverridden ? "warning" : "neutral"}
            className="whitespace-nowrap"
          >
            {formatDurationFromHours(netHours)}
          </TextBadge>
        )}
      </div>
      <DrawerDescription className="mt-4 text-left">
        <WeekStatusBadge status={weekStatus} className="whitespace-nowrap" />
      </DrawerDescription>
    </DrawerHeader>
  );
};

ShiftHeader.propTypes = {
  shift: ShiftShape.isRequired,
  shiftDate: PropTypes.instanceOf(Date).isRequired,
  weekStatus: PropTypes.string.isRequired,
};
